import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type ReplyIndicatorProps = {
  replyCount?: number;
};

export const ReplyIndicator: FC<ReplyIndicatorProps> = ({ replyCount }) => {
  const { t } = useTranslation('team-chat');

  return (
    <div css={styles.container}>
      <Text color='subdued' css={styles.text} size='medium'>
        {!!replyCount ? t('{{count}} replies', { count: replyCount }) : t('Reply in thread')}
      </Text>
      <div css={styles.divider} />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    width: 100%;
    align-items: center;
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(0.5, 0, 0.5, 1)};
  `,
  divider: css`
    height: 1px;
    background-color: ${theme.colors.neutral10};
    flex: 1;
  `,
  text: css`
    white-space: nowrap;
  `,
};

ReplyIndicator.displayName = 'ReplyIndicator';
